const Image = props => {
    return (<img loading={props.loading || "lazy"} alt={props.alt} src={props.src} decoding={props.decoding || "async"} fetchpriority={props.fetchpriority || "high"} class={props.class}/>);
};
export { Image };
